export default __webpack_public_path__ + "static/media/cbi_logo.73e3c931.png";